// builder-components.ts
import { Builder } from '@builder.io/react';

import CallCampaignTalkAgentButton from './talk-agent';

Builder.registerComponent(CallCampaignTalkAgentButton, {
  name: 'CallCampaignTalkAgentButton',
  noWrap: true,
});
